import axios from "fetch-api/fetch-api";

function getVehicleImage(queryString: string) {
  return axios.get(`s/get-vehicle-images-v2?${queryString}`);
}

export default getVehicleImage;
